export default __webpack_public_path__ + "static/media/img5.12da5e34.jpg";